<script>

  import { onMount } from "svelte";
  import {router} from "@spaceavocado/svelte-router";

  import { parseQuery } from "../lib/utils";
  import { verifyToken } from "../lib/wirus-integration";
  import firebase from "../lib/firebase";

  let query = parseQuery(window.location.search);

  if (query.token) {
    verifyToken(query.token)
      .then(token => {
        if (token) {
          return firebase
            .auth()
            .signInWithCustomToken(token)
            .then(() => $router.replace("/platform"));
        } else {
          $router.replace("/wirus");
        }
      })
      .catch((err) => {
        console.warn(err);
        $router.replace("/")
      });
  } else {
    $router.replace("/");
  }

 
</script>

<style>
.content-wrapper {
  padding-top: 40px;
}
i {
  color: #ff8811;
}
</style>

<div class="main">
  <div class="content-wrapper">
    <i class="fas fa-circle-notch fa-spin fa-4x" />
  </div>
</div>